export default __webpack_public_path__ + "static/moon_bunnies_d-81d8f5b2731c2ca4e1f3af5c72501ba4.jpg";